import React from 'react';
import { useTranslation } from 'react-i18next';
import { Constants } from '@pwc/pwc-deals-web-common';
import { useSelector } from 'react-redux';
import { getLoggedInUser } from '../../redux/security/loggedInUser/loggedInUserSelector';
import ShowForPermissions from '../../../features/security/ShowForPermissions';
import ShowForRole from '../../../features/security/ShowForRole';
import './EmptyContentCard.scss';

const EmptyContentCard = ({
  projectId,
  name,
  children,
  pluralName,
  singularName,
}) => {
  const loggedInUser = useSelector(getLoggedInUser) || { givenName: 'User' };
  const { t } = useTranslation();

  const dasherizedPluralName = pluralName
    ? pluralName.split(' ').join('-')
    : name.split(' ').join('-');
  const pluralNameCardTestId = `empty-${dasherizedPluralName}-card`;
  const pluralNameCardCreateTestId = `empty-${dasherizedPluralName}-card-create-content`;
  const nothingSharedMessage = t('noKFAsharedYet', {
    KFATitle: t(pluralName || name),
  });
  const nothingAddedMessage = t('noContentTypeHaveBeenAddedYet', {
    contentType: t(pluralName || name),
  });

  const helloMessage = t('helloUserName', {
    displayName: loggedInUser.givenName,
  });
  const createFirstMessage = t('createfirstkfaProject', {
    name: singularName || name,
  });

  return (
    <div
      className="empty-content-card content-container"
      data-testid={pluralNameCardTestId}
    >
      <ShowForRole
        projectId={projectId}
        roles={[
          ...Constants.USER_ROLE_GROUPS.CLIENT,
          ...Constants.USER_ROLE_GROUPS.THIRD_PARTY_MEMBER,
        ]}
      >
        <p className="nothing-shared">{nothingSharedMessage}</p>
      </ShowForRole>

      <ShowForRole
        projectId={projectId}
        roles={[
          Constants.USER_ROLES.PWC_READONLY_DISPLAY,
          Constants.USER_ROLES.PWC_READONLY,
        ]}
      >
        <p className="nothing-shared">{nothingAddedMessage}</p>
      </ShowForRole>

      <ShowForPermissions projectId={projectId} permissions={['Contribute']}>
        <div data-testid={pluralNameCardCreateTestId}>
          <h2>{helloMessage}</h2>
          <h2>{createFirstMessage}</h2>
          {children}
        </div>
      </ShowForPermissions>
    </div>
  );
};

export default EmptyContentCard;
